<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-header" style="padding: 0px !important">
                <div class="page-breadcrumb">
                    <div class="row">
                        <div class="col-5 align-self-center">
                            <h4 class="page-title">{{ $t("lang.label_m_g") }}</h4>
                        </div>
                        <div class="col-7 align-self-center">
                            <div class="d-flex align-items-right justify-content-end">
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item">
                                            <router-link
                                                :to="{ name: 'Setup' }"
                                                class="btn btn-info btn-sm mr-2"
                                            >
                                                <i class="fas fa-arrow-left"></i>
                                                {{ $t("lang.label_back") }}
                                            </router-link>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6">
                                <button @click="showModal" class="btn btn-primary">
                                    {{ $t("lang.label_add") }}
                                </button>
                            </div>
                            <div class="col-md-6">
                                <!-- <input
                                    type="text"
                                    v-model="search"
                                    class="form-control search"
                                /> -->
                            </div>
                        </div>
                        <br />
                        <table class="table table-hover" v-if="isLoading === true">
                            <thead>
                                <tr>
                                    <th>{{ $t("lang.label_n_g") }}</th>
                                    <th>{{ $t("lang.msj_status") }}</th>
                                    <th>{{ $t("lang.label_action") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colspan="10">
                                        <Loader v-if="isLoading"></Loader>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-hover" v-else>
                            <thead>
                                <tr>
                                    <th style="width: 70%">{{ $t("lang.label_n_g") }}</th>
                                    <th style="width: 10%">{{ $t("lang.msj_status") }}</th>
                                    <th colspan="2" style="width: 10%; text-align: center;">{{ $t("lang.label_action") }}</th>
                                </tr>
                            </thead>
                            <!-- <tr v-if="primario.length > 0">
                                <td style="padding: 12px;">
                                    {{primario[0].name}}
                                </td>
                                <td>
                                    <span class="badge badge-success" style="">{{
                                        $t("lang.label_default")
                                    }}</span>
                                </td>
                                <td>
                                </td>
                            </tr> -->
                            <draggable
                                v-model="mGroup"
                                tag="tbody"
                                class="tbody"
                                group="menuGroupp"
                                @start="isDragging = true"
                                @end="isDragging = false"
                                @change="moveGroup"
                                handle=".moveCat"
                            >
                                <tr
                                    v-for="(i, index) in filterItems"
                                    :key="index"                                    
                                >
                                    <td style="padding-top: 7px;padding-bottom: 7px;">
                                        <div class="moveCat">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </div>
                                        <input
                                            type="text"
                                            v-model="i.name"
                                            v-on:change="editCamp(i)"
                                            v-bind:class="[
                                                i.name ? 'custom_mini' : '',
                                                'form-control editables',
                                            ]"
                                        />
                                    </td>
                                    <td style="padding-top: 7px;padding-bottom: 7px;" v-if="i.primary_group === 0">
                                        <div class="swiches">
                                            <label class="switch">
                                                <input
                                                    type="checkbox"
                                                    :checked="i.activo"
                                                    v-model="filterItems[index].activo"
                                                    @click="checke(i)"
                                                />
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td v-else style="padding-top: 7px;padding-bottom: 7px;">
                                        <span class="badge badge-success" style="">{{ $t("lang.label_default") }}</span>
                                    </td>                                    
                                    <td style="padding-top: 7px;padding-bottom: 7px;" v-if="i.primary_group === 0">
                                        <button
                                            type="submit"
                                            class="btn btn-success"
                                            @click="showModal(i, index)"
                                            style="margin-right: 6px;"
                                        >
                                            <i class="fas fa-pen fa-ms"></i>
                                        </button>
                                    </td>
                                    <td v-else style="padding-top: 7px;padding-bottom: 7px;"></td>
                                    <td style="padding-top: 7px;padding-bottom: 7px;" v-if="i.primary_group === 0">
                                        <button
                                            type="submit"
                                            class="btn btn-danger"
                                            @click="removeGroup(i)"
                                        >
                                            <i class="fas fa-trash fa-ms"></i>
                                        </button>
                                    </td>
                                    <td v-else style="padding-top: 7px;padding-bottom: 7px;"></td>
                                </tr>
                            </draggable>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <modal
            name="modal_menuGroup"
            height="auto"
            width="400px"
            :resizable="true"
            :adaptive="true"
            :scrollable="true"
        >
            <div class="card-header">
                {{ $t("lang.label_m_g") }}
                <button @click="closeModal" class="closeIcon"><span></span></button>
            </div>
            <div class="card-body">
                <form @submit.prevent="form()">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label>{{ $t("lang.label_nn_g") }}:</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>{{ $t("lang.label_n_g") }}:</label>
                            <input
                                type="text"
                                class="form-control"
                                style="border: 1px solid #b1b1b1"
                                v-model="f.name"
                            />
                        </div>
                        <div class="form-group col-md-12" v-if="f.primary_group === 0">
                            <label>{{ $t("lang.msj_status") }}:</label>
                            <select v-model="f.status" class="form-control">
                                <option value="1">{{ $t("lang.msj_active") }}</option>
                                <option value="0">{{ $t("lang.msj_inactive") }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-2">
                            <button
                                type="submit"
                                class="btn btn-info"
                                :disabled="btnSave"
                            >
                                <i class="fas fa-save fa-ms"></i>
                                {{ $t("lang.label_save") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </modal>
        <notifications group="noti" position="top center"></notifications>
    </div>
</template>
<script>
import draggable from "vuedraggable";
import Loader from "@/components/shared/Loader.vue";
import axios from "axios";
export default {
    name: "MenuGroup",
    components: {
        Loader,
        draggable,
    },
    data () {
        return {
            isLoading: false,
            isDragging: false,
            mGroup: [],
            f: {
                name: "",
                status: 1,
                user_id: window.localAccountID,
                org_id: window.localorgdata,
                order: 0,
                id: 0,
                primary_group: 0,
            },
            btnSave: false,
            search: "",
            primario: [],
        };
    },
    created () {
        this.getGrout();
    },
    methods: {
        editCamp(b) {
            if (b.name === "") {
                this.$swal({
                    title: "Error",
                    text: window.lang2.abel_itis_empty,
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                });
                this.getGrout();
            } else {
                this.f.status = b.activo;
                this.f.id = b.id;
                this.f.name = b.name;
                this.f.primary_group = b.primary_group;
                window.master
                    .post("/editgroup", this.f)
                    .then((response) => {
                        console.log(response.data);
                        this.getGrout();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        checke(i) {
            window.master
                .post("/onoffgroup", i)
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showModal(i, index) {
            if (index !== undefined) {
                this.f.name = i.name;
                this.f.status = i.activo;
                this.f.id = i.id;
                this.f.primary_group = i.primary_group;
            }
            this.$modal.show("modal_menuGroup");
        },
        closeModal() {
            this.$modal.hide("modal_menuGroup");
            this.empty();
        },
        empty() {
            this.f.name = "";
            this.f.status = 1;
            this.f.id = 0;
            this.f.primary_group = 0;
        },
        removeGroup(i) {
            this.$swal({
                title: window.lang2.label_d_g,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    window.master
                        .post("/delgroup", i)
                        .then((response) => {
                            console.log(response);
                            if (response.data.status === true) {
                                this.getGrout();
                            } else {
                                this.$notify({
                                    group: "noti",
                                    title: "ERROR",
                                    type: "error",
                                    text: window.lang2.label_dl_cat_asg,
                                });
                            }
                            this.isLoading = false;
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        moveGroup() {
            window.master
                .post("/movegroup", { move: this.mGroup })
                .then((response) => {
                    this.mGroup = response.data.list;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getGrout() {
            window.master
                .post("/getgroups", this.f)
                .then((response) => {
                    this.mGroup = response.data.result;
                    // console.log(this.mGroup);
                    let d = this.mGroup;
                    let k = [];
                    for (const i in d) {
                        if (d[i].primary_group === 1) {
                            k.push(d[i]);
                        }
                    }
                    this.primario = k;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        form() {
            if (this.f.name.length > 0 || this.f.name !== "") {
                this.btnSave = true;
                let url = "/creategroup";
                if (this.f.id > 0) {
                    url = "/editgroup";
                }
                window.master
                    .post(url, this.f)
                    .then((response) => {
                        this.$modal.hide("modal_menuGroup");
                        this.$notify({
                            group: "noti",
                            title: window.lang2.label_save,
                            type: window.lang2.success,
                            text: window.lang2.label_success_send,
                        });
                        this.btnSave = false;
                        this.empty();
                        this.getGrout();
                    })
                    .catch((error) => {
                        console.log(error);
                        this.btnSave = false;
                    });
            } else {
                this.btnSave = false;
                this.$notify({
                    group: "noti",
                    title: "ERROR",
                    type: "error",
                    text: window.lang2.label_name_empty,
                });
            }
        },
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "menuGroupp",
                disabled: false,
                ghostClass: "ghost",
            };
        },
        filterItems: function () {
            var self = this;
            if (this.search !== "") {
                return this.mGroup.filter(function (item) {
                    if (item.name && item.name.indexOf(self.search.toLowerCase()) >= 0) {
                        return item;
                    }
                });
            } else {
                return this.mGroup.filter(function (item) {
                    if (item.name && item.name.indexOf(self.search.toLowerCase()) >= 0) {
                        return item;
                    }
                });
            }
        },
    },
}
</script>
<style scoped>
.moveCat {
    position: absolute;
    border: 0px solid #000;
    left: 5px;
    padding-top: 9px;
    padding-right: 2px;
    padding-bottom: 3px;
    padding-left: 4px;    
    height: 35px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    background-color: rgb(17 177 245 / 38%);
    cursor: move;
    top: inherit;
}

.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    border-radius: 34px;
}
.swiches .slider {
    border-radius: 50px;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.slider:before {
    border-radius: 50px;
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .slider {
    background-color: #2196f3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(17px);
    -ms-transform: translateX(17px);
    transform: translateX(17px);
}
.item-category {
    width: 100%;
}
.table th,
.table td {
    padding: 0px;
    padding-left: 10px;
}
.search {
    border-color: #555;
}
.form-control.editables {
    border: 0px;
    box-shadow: none;
    background: transparent;
    font-size: 12px;
    padding: 0px;
    height: 30px;
}
.vue-notification-group {
    top: 60px !important;
}
</style>
